// Format time in MM:SS and also return in milliseconds
export const formatTime = (seconds: number): string => {
    if (isNaN(seconds) || seconds < 0) {
        return '00:00'; // Default fallback value
    }

    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);

    return `${minutes.toString().padStart(2, '0')}:${secs
        .toString()
        .padStart(2, '0')}`;
};

export const parseTime = (time: string): number => {
    if (!/^\d{2}:\d{2}$/.test(time)) {
        throw new Error('Invalid time format. Expected format: MM:SS');
    }

    const [minutes, seconds] = time.split(':').map(Number);

    if (
        isNaN(minutes) ||
        isNaN(seconds) ||
        minutes < 0 ||
        seconds < 0 ||
        seconds >= 60
    ) {
        throw new Error(
            'Invalid time values. Minutes and seconds should be non-negative, and seconds should be less than 60.'
        );
    }

    return minutes * 60 + seconds;
};

// Return total duration in milliseconds
export const getTimeInMilliseconds = (seconds: number): number => {
    return Math.floor(seconds * 1000);
};

// Event handler for updating the current time
export const handleTimeUpdate = (
    videoElement: HTMLVideoElement | null,
    setCurrentTime: (time: string) => void
) => {
    if (videoElement) {
        const currentTime = videoElement.currentTime;
        setCurrentTime(formatTime(currentTime));
    }
};

// Event handler for setting the total duration
export const handleLoadedMetadata = (
    videoElement: HTMLVideoElement | null,
    setTotalDuration: (time: string) => void,
    setTotalMilliseconds: (ms: number) => void
) => {
    if (videoElement) {
        const duration = videoElement.duration;
        setTotalDuration(formatTime(duration));
        setTotalMilliseconds(getTimeInMilliseconds(duration));
    }
};

// Event handler for displaying the play button when video ends
export const handleVideoEnd = (setIsPlaying: (isPlaying: boolean) => void) => {
    setIsPlaying(false); // Reset play state when video ends
};

// Reset the video to the start position when it ends
export const handleVideoReset = (videoElement: HTMLVideoElement | null) => {
    if (videoElement) {
        videoElement.currentTime = 0; // Reset the video time to the start position
    }
};
